'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'image';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f03e';
var svgPathData = ['M16 48l0 416 416 0 0-416-416 0zM64 416l11.2-16 91.5-130.7 9.3-13.3 11.5 11.5 .6 .6 11.6 11.6c1.1-1.7 16.6-25.9 46.6-72.5L256 192c3 5.2 6 10.4 9 15.7L374.9 400 384 416 64 416zM176 160a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z', 'M432 48l0 416-416 0 0-416 416 0zM16 32l-16 0 0 448 448 0 0-448-432 0zm112 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm59.5 59.5l-11.5-11.5-9.3 13.3-91.5 130.7-11.2 16 320 0-9.1-16-109.9-192.3-9-15.7c-1.8 2.9-17.7 27.5-47.5 73.9l-8.9 13.8-11.6-11.6-.6-.6zm25.6 20.8l42.1-65.5 101.2 177.2-261.7 0 83.4-119.2c6.1 6.1 14.2 14.2 24.2 24.2l10.7-16.7z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faImage = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;